import { connect } from 'react-redux'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core'

import { SourceOptionBase } from './SourceOption'

import { modalActions } from 'reduxModules/actions/ModalActions'
import { sourceActions } from 'reduxModules/actions/SourceActions'

import { styles } from './styles'

const mapDispatchToProps = {
  showModal: modalActions.showModal,
  resetSource: sourceActions.resetSource
}

const enhance = compose(
  connect(null, mapDispatchToProps),
  withStyles(styles)
)

export const SourceOption = enhance(SourceOptionBase)



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceOption/index.js